<template>
  <div v-if="showPage">
    <h2 class="text-center py-3">
      Hayrat Eğitim Monitör <br>
    </h2>

    <!--server verileri burdan geliyor-->
    <ApexServerData
        :y_mesaj="'Sunucular Ait Bilgiler'"
    />
    <hr>
    <!--tahmini katilimci burada gelecek-->
    <h4 class="d-flex justify-content-center">18 Saatlik Tahmini Katılımcı</h4>
    <ApexTahminiKatilimci
        :y_mesaj="'Tahmini Katilimci Adedi'"
    />
    <hr>
    <h4 class="d-flex justify-content-center">18 Saatlik Oturum Adedi</h4>
    <hr>
    <ApexOturumAdedi
        :y_mesaj="'Olusturulacak Oturum Adedi'"
    />
  </div>
  <!--  sifre alaninin gosterilecegi alan-->
  <div v-else class="d-flex justify-content-center align-items-center vh-100">
    <div>
      <b-btn variant="success" @click="showPasswordModal=true">Parolayı girecem, tamam</b-btn>
    </div>
    <b-modal v-model="showPasswordModal" hide-footer title="Parola">
      <form class="d-flex justify-content-center" method="post" @submit.prevent="passwordSubmit">
        <b-form-row>
          <b-form-group label="Parola">
            <b-input v-model="password" placeholder="Parola" type="password"/>
          </b-form-group>
        </b-form-row>
      </form>
    </b-modal>

  </div>
</template>
<script>
import ApexOturumAdedi from "@/components/ApexOturumAdedi";
import ApexTahminiKatilimci from "@/components/ApexTahminiKatilimci";
import ApexServerData from "@/components/ApexServerData";
import loading from "@/components/LoadingSpiner";


import customMoment from 'moment'
import {Turkish} from "flatpickr/dist/l10n/tr.js";

customMoment.locale('tr')

export default {
  name: 'Home',
  components: {
    ApexServerData,
    ApexOturumAdedi,
    ApexTahminiKatilimci,
    loading,
  },
  data() {
    return {
      time: 15,
      dateTimeConfig: {
        altInput: true,
        allowInput: true,
        dateFormat: 'Z',
        altFormat: 'd-M-Y',
        locale: Turkish
      },
      moment: customMoment,
      startDate: new Date(),
      endDate: new Date(),
      // Server Data guncellenme araligi
      password: '',
      showPasswordModal: false,
      showPage: false,
    }
  },

  // component ilk olusturulurken buradan yonleniyor
  async created() {
    const password = localStorage.getItem('bbbservis-monitor-password')
    if (password && password.toLowerCase() === 'bismillah') {
      this.showPage = true;
    } else {
      this.showPasswordModal = true;
    }
  },

  methods: {
    // Parola kontrol
    async passwordSubmit() {
      if (this.password.toLowerCase() === 'bismillah') {
        localStorage.setItem('bbbservis-monitor-password', this.password)
        this.showPage = true
      } else {
        this.showErrorMessageToast('Girilen şifre yanliş. Neden ??')
      }
    },
  },
}
</script>
